import React from 'react';
import different from '../../img/different.png'

const OurDifferent = () => {
    return (
        <div className='grid grid-cols-1 md:grid-cols-2 px-4 md:px-12 gap-4 md:gap-6 bg-sky-700'>
            <div className='py-6'>
                <img className='rounded-3xl' src={different} alt="" />
            </div>
            <div>
                <h1 className='text-2xl md:text-4xl text-white font-semibold text-center py-4'>What Makes Us Different?</h1>
                <p className='text-white text-sm lg:text-base'>1.	Career Hikers was established with the intention of providing the most accurate and helpful career guidance and counselling to students in order for them to locate the right, satisfied, and fulfilling career, as well as make the right choices to become a successful individual. <br /><br />
                    2.	We provide students with the opportunity to consult with the finest counsellors in their field in person. Through learning from others' experiences and working more efficiently and effectively towards their objectives, students can improve their chances.<br /><br />
                    3.	We have hand-selected a group of top performers from a range of locations, cultures, and experiences in the past. Because they have been there themselves and are familiar with all of the challenges that one might face, our experts can assist and counsel students in their critical journey to locating their ideal career opportunities. <br /><br />
                    4.	Our team is capable of assisting and counselling students in their quest to find the best employment opportunities. <br /><br />
                </p>
            </div>
        </div>
    );
};

export default OurDifferent;